module.exports = __webpack_public_path__ + "media/images/icon/ico_datepicker-06d222ba790fac6923cbb57a8df0bd61.png";